import { Injectable } from '@angular/core';
import { UserDetails } from '../../core/models/user-details.model';
import { role } from '../constants/role-enum';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoggedInUserService {
    private _userDetails: UserDetails = {
        userId: -1,
        firstName: '',
        lastName: '',
        userNameInitials: '',
        email: '',
        roleId: role.none,
        permissions: [],
    };

    private _loggedInUserSubject = new BehaviorSubject<UserDetails>(this._userDetails);

    public loggedInUser$ = this._loggedInUserSubject.asObservable();

    constructor() { }

    setUserDetails(value: UserDetails) {
        this._userDetails = value;
        this._loggedInUserSubject.next(value);
    }
}
